/* ============================================================
   Journey design system — global controller (window.PJ).
   Loaded once (deferred) by layout/theme.journey.liquid.
   Centralises: member/guest view, cart drawer + add-to-cart,
   Fit Quiz (built-in modal → Klaviyo) and live pet personalisation.

   Data attributes it drives:
     [data-pj-config]            hidden el carrying config (logged-in, demo, threshold, klaviyo key/list, pet + demo profile, routes)
     [data-pj-only="member|guest"]  shown/hidden by current view
     [data-pj-haspet]            shown when an active pet profile exists (login, quiz or demo)
     [data-pj-petname]           text filled with the active pet's name
     [data-pj-fit]               fit badge; evaluated client-side against the active pet (modes 'card' / 'pdp')
     [data-pj-member] / [data-pj-guest]  staging preview toggle buttons
     [data-pj-cartcount] [data-pj-cart-open] [data-pj-add]   cart
     [data-pj-quiz]              opens the Fit Quiz modal
   Quiz modal (snippet pj-quiz): [data-pj-quiz-modal] [data-pj-quiz-scrim] [data-pj-quiz-close]
     [data-pj-step] [data-pj-opt] [data-pj-field] [data-pj-optin] [data-pj-next] [data-pj-back]
     [data-pj-submit] [data-pj-quiz-progress] [data-pj-quiz-name] [data-pj-quiz-msg]
   ============================================================ */
(function () {
  if (window.PJ) return;
  var cfg = {};
  var view = 'guest';

  function readConfig() {
    var el = document.querySelector('[data-pj-config]');
    function a(n, d) { return el ? (el.getAttribute(n) || d || '') : (d || ''); }
    cfg = {
      loggedIn: el ? el.getAttribute('data-logged-in') === 'true' : false,
      demo: el ? el.getAttribute('data-demo') === 'true' : false,
      threshold: el ? parseInt(el.getAttribute('data-threshold'), 10) || 0 : 0,
      klaviyoForm: a('data-klaviyo-form'),
      klaviyoKey: a('data-klaviyo-key'),
      emailList: a('data-email-list'),
      serverPet: { name: a('data-pet-name'), owner: a('data-owner-name'), species: a('data-pet-species'), stage: a('data-pet-stage'), size: a('data-pet-size') },
      demoPet: { name: a('data-demo-name', 'your pet'), species: a('data-demo-species'), stage: a('data-demo-stage'), size: a('data-demo-size') },
      cartUrl: a('data-cart-url', '/cart'),
      cartAddUrl: a('data-cart-add-url', '/cart/add'),
      cartChangeUrl: a('data-cart-change-url', '/cart/change'),
      registerUrl: a('data-register-url', '/account/register'),
      pawsLive: (el ? el.getAttribute('data-paws-live') : '') === 'true',
      pawsProxy: a('data-paws-proxy'),
      pawsFallback: a('data-paws-fallback'),
      customerId: a('data-customer-id'),
      customerEmail: a('data-customer-email'),
      pawsSig: a('data-paws-sig')
    };
    view = (cfg.loggedIn || localPet()) ? 'member' : 'guest';
    if (cfg.demo) { try { var s = localStorage.getItem('tps_view'); if (s) { view = s === 'guest' ? 'guest' : 'member'; } } catch (e) {} }

    // Multi-pet list (from custom.pets json) — maps to the engine's pet shape.
    cfg.petsList = [];
    try {
      var rawPets = a('data-pets');
      if (rawPets) {
        var parsed = JSON.parse(rawPets);
        if (Array.isArray(parsed)) {
          cfg.petsList = parsed.map(mapPetShape).filter(function (p) { return p.name; });
        }
      }
    } catch (e) {}
  }

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function $all(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // Wrong-pet guard: on a species page whose species (or life stage) doesn't match the ACTIVE pet
  // (Koda the dog on /collections/cat), pet-personalised copy must not render — "Everything Koda
  // needs to thrive" on the cat page reads broken. Pet-scoped member elements (data-pj-petscope)
  // fall back to their guest twin, and a "crossshop" nudge invites adding the other pet to the Pack.
  function speciesMismatch() {
    if (view !== 'member') return false;
    var pageEl = document.querySelector('[data-pj-species]');
    if (!pageEl) return false;
    var pet = getPet();
    if (!pet || !pet.species) return false;
    var norm = function (s) { return String(s || '').toLowerCase().replace(/[^a-z]/g, ''); };
    if (norm(pageEl.getAttribute('data-pj-species')) !== norm(pet.species)) return true;
    var stg = pageEl.getAttribute('data-pj-stage');                     // puppy/kitten life-stage pages
    if (stg && norm(stg) !== norm(pet.stage)) return true;
    return false;
  }
  function applyView() {
    var mismatch = speciesMismatch();
    $all('[data-pj-only]').forEach(function (el) {
      var only = el.getAttribute('data-pj-only');
      if (only === 'crossshop') { el.style.display = mismatch ? '' : 'none'; return; }
      var effView = (mismatch && el.hasAttribute('data-pj-petscope')) ? 'guest' : view;
      el.style.display = (only === effView) ? '' : 'none';
    });
    var mb = document.querySelector('[data-pj-member]'), gb = document.querySelector('[data-pj-guest]');
    if (mb && gb) {
      mb.style.background = view === 'member' ? '#FCCB1E' : 'transparent';
      mb.style.color = view === 'member' ? '#43306E' : '#C9BEE3';
      gb.style.background = view === 'guest' ? '#FCCB1E' : 'transparent';
      gb.style.color = view === 'guest' ? '#43306E' : '#C9BEE3';
    }
  }
  function setView(v) {
    view = v;
    if (cfg.demo) { try { localStorage.setItem('tps_view', v); } catch (e) {} }
    applyView();
    applyPersonalization();
    document.dispatchEvent(new CustomEvent('pj:view', { detail: { view: v } }));
  }

  /* ---- pet personalisation ---- */
  function localPet() {
    try { var q = JSON.parse(localStorage.getItem('tps_pet') || 'null'); if (q && q.species) return q; } catch (e) {}
    return null;
  }
  function activePetName() {
    try { var s = localStorage.getItem('tps_active_pet'); if (s) return s; } catch (e) {}
    return null;
  }
  function getActivePet() {
    if (!cfg.petsList || !cfg.petsList.length) return null;
    var sel = activePetName();
    // Match by id first (names can collide); fall back to name for values stored before this change.
    if (sel) { for (var i = 0; i < cfg.petsList.length; i++) { if ((cfg.petsList[i].id && cfg.petsList[i].id === sel) || cfg.petsList[i].name === sel) return cfg.petsList[i]; } }
    for (var j = 0; j < cfg.petsList.length; j++) { if (cfg.petsList[j].primary) return cfg.petsList[j]; }
    return cfg.petsList[0];
  }
  function getPet() {
    var multi = getActivePet();                                        // logged-in customer's selected/primary pet (custom.pets)
    if (multi) return multi;
    if (cfg.serverPet && cfg.serverPet.name) return cfg.serverPet;     // back-compat: single pet via the flat mirror
    var q = localPet();                                                // this visitor's Fit Quiz answers
    if (q) return q;
    if (cfg.demo && view === 'member' && cfg.demoPet && cfg.demoPet.species) return cfg.demoPet; // staging preview only
    return null;
  }
  function setActivePet(name) {
    try { localStorage.setItem('tps_active_pet', name); } catch (e) {}
    applyPersonalization();
    renderPetSwitch();
    renderAccountPets();
    closePetSwitch();
  }
  function listHas(attr, val) {
    if (!val) return false;
    var arr = (attr || '').toLowerCase().split(',');
    return arr.indexOf(val.toLowerCase()) !== -1;
  }
  // returns 'yes' | 'weak' | 'no' | 'other' | 'none'
  // 'weak' = the species matches but the product carries no per-pet signal (all-stages taxonomy
  // backfill, no breed_size, or no animal_type). Card pills show ONLY on a strong 'yes'; the PDP
  // shows the softer "not sure? find fit" prompt on 'weak'. This stops the badge degenerating to a
  // species-only "shows on everything" match (2026-07-04 audit).
  function fitFor(box, pet) {
    if (!pet) return 'none';
    if (!listHas(box.getAttribute('data-fit-species'), pet.species)) return 'other';
    var spl = (pet.species || '').toLowerCase();
    if (spl === 'dog' || spl === 'cat') {
      var stages = box.getAttribute('data-fit-stages') || '';
      if (!stages) return 'other';
      if (!listHas(stages, pet.stage)) return 'no';
      var sizes = box.getAttribute('data-fit-sizes') || '';
      if (sizes) { return listHas(sizes, pet.size) ? 'yes' : 'no'; }
      // No breed_size on the product. A 3+-stage list is the stage-agnostic backfill (toys/beds/
      // bowls given all stages so the badge could fire) → no real per-pet signal, so 'weak'.
      return ((stages.toLowerCase().split(',').length >= 3) ? 'weak' : 'yes');
    }
    // other species: match on animal type. No type on the product (or on the pet) means
    // species-only — 'weak', not a blanket 'yes' that badges every product of the species.
    var types = box.getAttribute('data-fit-types') || '';
    if (!types) return 'weak';
    if (!pet.type) return 'weak';
    return listHas(types, pet.type) ? 'yes' : 'no';
  }
  function applyPersonalization() {
    var pet = getPet();
    var nm = (pet && pet.name) ? String(pet.name).trim() : 'your pet';
    $all('[data-pj-petname]').forEach(function (e) { e.textContent = nm; });
    var avem = pet ? speciesEmoji(pet.species, pet.stage) : '🐾';
    $all('[data-pj-petavatar]').forEach(function (e) { e.textContent = avem; });
    $all('[data-pj-haspet]').forEach(function (e) { e.classList.toggle('pj-hide', !pet); });
    $all('[data-pj-nopet]').forEach(function (e) { e.classList.toggle('pj-hide', !!pet); });
    var ow = (pet && pet.owner) ? pet.owner : 'friend';
    $all('[data-pj-ownername]').forEach(function (e) { e.textContent = ow; });
    var sp = (pet && pet.species) ? pet.species.toLowerCase().replace(/\s+/g, '-') : '';
    var spKnown = ['dog', 'cat', 'fish', 'bird', 'small-animal', 'reptile', 'horse'];
    var stg = (pet && pet.stage) ? pet.stage.toLowerCase() : '';
    var shopHref = spKnown.indexOf(sp) !== -1 ? ('/collections/' + sp) : '/collections/all';
    // Puppies/kittens land on their dedicated life-stage page instead of the species page.
    if (sp === 'dog' && stg === 'puppy') shopHref = '/collections/puppy';
    else if (sp === 'cat' && stg === 'kitten') shopHref = '/collections/kitten';
    $all('[data-pj-shopspecies]').forEach(function (e) { e.setAttribute('href', shopHref); });
    $all('[data-pj-fit]').forEach(function (box) {
      var r = fitFor(box, pet);
      if (box.getAttribute('data-fit-mode') === 'card') {
        box.style.display = (r === 'yes') ? 'inline-block' : 'none';
      } else {
        var yes = box.querySelector('[data-pj-fit-yes]'), no = box.querySelector('[data-pj-fit-no]'), ask = box.querySelector('[data-pj-fit-ask]');
        box.style.display = (r === 'other') ? 'none' : '';
        if (yes) yes.style.display = (r === 'yes') ? 'flex' : 'none';
        if (no) no.style.display = (r === 'no') ? 'flex' : 'none';
        if (ask) ask.style.display = (r === 'none' || r === 'weak') ? 'flex' : 'none';
      }
    });
  }

  // Little species emoji for pet avatars (header pill, switcher, account cards).
  function speciesEmoji(species, stage) {
    var s = String(species || '').toLowerCase();
    if (s.indexOf('dog') >= 0) return '🐶';
    if (s.indexOf('cat') >= 0) return '🐱';
    if (s.indexOf('fish') >= 0) return '🐠';
    if (s.indexOf('bird') >= 0) return '🦜';
    if (s.indexOf('small') >= 0 || s.indexOf('rabbit') >= 0) return '🐰';
    if (s.indexOf('reptile') >= 0) return '🦎';
    if (s.indexOf('horse') >= 0) return '🐴';
    return '🐾';
  }
  // Map a stored custom.pets record → the engine's pet shape (keeps id/dietary/birthday for the editor).
  function mapPetShape(p) {
    return {
      id: p.id || '', name: (p.name || '').trim(), owner: (cfg.serverPet && cfg.serverPet.owner) || '',
      species: p.species || '', stage: p.life_stage || '', size: p.breed_size || '',
      dietary: p.dietary || '', birthday: p.birthday || '', type: p.animal_type || '', primary: !!p.primary
    };
  }

  /* ---- pet switcher (multi-pet) ---- */
  function petSwitchEl() { return document.querySelector('[data-pj-petswitch]'); }
  function petSwitchCol() { var w = petSwitchEl(); return w ? w.closest('.header__icons--right') : null; }
  function petSwitchToggle() { return document.querySelector('[data-pj-petswitch-toggle]'); }
  function openPetSwitch() { var w = petSwitchEl(); if (w) w.classList.remove('pj-hide'); var c = petSwitchCol(); if (c) c.classList.add('pj-ps-up'); var t = petSwitchToggle(); if (t) t.setAttribute('aria-expanded', 'true'); }
  function closePetSwitch() { var w = petSwitchEl(); if (w) w.classList.add('pj-hide'); var c = petSwitchCol(); if (c) c.classList.remove('pj-ps-up'); var t = petSwitchToggle(); if (t) t.setAttribute('aria-expanded', 'false'); }
  function togglePetSwitch() { var w = petSwitchEl(); if (!w) return; var hidden = w.classList.toggle('pj-hide'); var c = petSwitchCol(); if (c) c.classList.toggle('pj-ps-up', !hidden); var t = petSwitchToggle(); if (t) t.setAttribute('aria-expanded', hidden ? 'false' : 'true'); }
  function switchPets() {
    // Members: the custom.pets list. Quiz guests / single-pet members: the active pet alone,
    // so the pill always opens SOMETHING (dead-tap on mobile was an owner UAT catch, 2026-07-16).
    // getPet(), not getActivePet(): the latter only reads the member list and returns null for
    // quiz guests — the exact dead-tap being fixed. Quiz pets may be nameless (name is optional).
    var pets = (cfg.petsList && cfg.petsList.length) ? cfg.petsList : [];
    if (!pets.length) { var ap = getPet(); if (ap && (ap.name || ap.species)) pets = [ap]; }
    return pets;
  }
  function renderPetSwitch() {
    var chev = document.querySelector('[data-pj-petswitch-chev]');
    var wrap = petSwitchEl();
    var pets = switchPets();
    var multi = pets.length > 1;
    if (chev) chev.style.display = pets.length ? '' : 'none';
    if (!wrap) return;
    if (!pets.length) { wrap.innerHTML = ''; return; }
    var active = getActivePet();
    var activeKey = active ? (active.id || active.name) : null;
    wrap.innerHTML = '';
    var hd = document.createElement('div');
    hd.style.cssText = 'font-size:10px;color:#7A6E96;text-transform:uppercase;letter-spacing:.05em;padding:6px 10px 5px;';
    hd.textContent = multi ? 'Switch pet' : 'Your pet';
    wrap.appendChild(hd);
    pets.forEach(function (p) {
      var on = multi ? (activeKey != null && (p.id || p.name) === activeKey) : true;
      var b = document.createElement('button');
      b.type = 'button';
      b.style.cssText = 'display:flex;align-items:center;gap:10px;width:100%;text-align:left;background:' + (on ? '#F2EAFD' : '#fff') + ';border:none;border-radius:9px;padding:8px 10px;cursor:' + (multi ? 'pointer' : 'default') + ';font-family:inherit;';
      b.innerHTML = '<span style="width:26px;height:26px;border-radius:99px;background:#EFE7FB;flex:none;display:flex;align-items:center;justify-content:center;font-size:15px;line-height:1;">' + speciesEmoji(p.species, p.stage) + '</span>' +
        '<span style="flex:1;min-width:0;"><span class="gs" style="display:block;font-size:13px;font-weight:600;color:#241B3A;">' + esc(p.name || 'Your pet') + '</span>' +
        '<span style="font-size:11px;color:#7A6E96;">' + esc(p.species) + (p.stage ? ' · ' + esc(p.stage) : '') + '</span></span>' +
        (on ? '<span style="color:#5C4295;font-size:14px;flex:none;">✓</span>' : '');
      if (multi) { b.addEventListener('click', function () { setActivePet(p.id || p.name); }); }
      wrap.appendChild(b);
    });
    // "Add a pet": members manage pets in the account modal; guests are invited to sign in
    // (data-pj-login opens Shopify's sign-in sheet, href is the 700ms fallback).
    var add;
    if (cfg.loggedIn) {
      add = document.createElement('button');
      add.type = 'button';
      add.setAttribute('data-pj-account', '');
      add.setAttribute('data-pj-acct-open', 'pets');
    } else {
      add = document.createElement('a');
      add.href = '/account/login';
      add.setAttribute('data-pj-login', '');
    }
    add.className = 'qa';
    add.style.cssText = 'display:flex;align-items:center;gap:10px;width:100%;text-align:left;background:#fff;border:none;border-top:1px solid #EFE7FB;border-radius:0 0 9px 9px;margin-top:4px;padding:9px 10px 8px;cursor:pointer;font-family:inherit;text-decoration:none;';
    add.innerHTML = '<span style="width:26px;height:26px;border-radius:99px;background:#F2EAFD;border:1px dashed #C9B6EE;flex:none;display:flex;align-items:center;justify-content:center;font-size:16px;line-height:1;color:#5C4295;">+</span>' +
      '<span style="flex:1;min-width:0;"><span class="gs" style="display:block;font-size:13px;font-weight:600;color:#241B3A;">Add a pet</span>' +
      '<span style="font-size:11px;color:#7A6E96;">' + (cfg.loggedIn ? 'Manage pet profiles' : 'Sign in to save your pets') + '</span></span>';
    add.addEventListener('click', function () { closePetSwitch(); });
    wrap.appendChild(add);
  }

  /* ---- Paws (Influence.io loyalty) — read the real balance via the tps-services proxy ----
     Inert by default: only fires when the kill switch (data-paws-live) is ON, a proxy URL is
     set, and there's a signed logged-in identity. On guest / fail-soft, the static Liquid
     fallback ([data-pj-paws-*] inner text) is left untouched. Earn-line wiring (real rate) is
     a later step — these hooks just give applyPaws()/future code something to fill. */
  function formatPaws(n) { try { return Number(n).toLocaleString(); } catch (e) { return String(n); } }
  function fillPaws(p) {
    if (!p) return;
    if (p.balance != null) { $all('[data-pj-paws-balance]').forEach(function (e) { e.textContent = formatPaws(p.balance); }); }
    if (p.tier) {
      $all('[data-pj-paws-tier]').forEach(function (e) { e.textContent = p.tier; });
      $all('[data-pj-tier-col]').forEach(function (e) { e.classList.toggle('is-current', e.getAttribute('data-pj-tier-col') === p.tier); });
      $all('[data-pj-tier-you]').forEach(function (e) { e.style.display = (e.getAttribute('data-pj-tier-you') === p.tier) ? 'inline-block' : 'none'; });
      // expose the tier earn multiplier for the PDP per-item Paws line (Companion 1x / Best Friend 1.25x / Soulmate 1.5x)
      var tl = String(p.tier).toLowerCase();
      window.__pjTierMult = tl.indexOf('soulmate') !== -1 ? 1.5 : (tl.indexOf('best') !== -1 ? 1.25 : 1);
      window.__pjTierName = p.tier;
      try { document.dispatchEvent(new CustomEvent('pj:paws-tier')); } catch (e) {}
    }
    if (p.progress != null) { $all('[data-pj-paws-progress]').forEach(function (e) { e.style.width = Math.max(0, Math.min(100, p.progress)) + '%'; }); }
    // "X Paws to <next tier>" — only on a full Paws payload, not a balance-only redeem update
    if ('next' in p) {
      if (p.next != null) {
        $all('[data-pj-paws-next]').forEach(function (e) { e.textContent = formatPaws(p.next); });
        if (p.nextTier) { $all('[data-pj-paws-nexttier]').forEach(function (e) { e.textContent = p.nextTier; }); }
      } else {                                                            // top tier — no "next"
        $all('[data-pj-paws-nextline]').forEach(function (e) { e.textContent = 'Top of the pack — you’re a ' + (p.tier || 'legend') + ' 🐾'; });
      }
    }
  }
  // No live balance available for a REAL signed-in member → neutralise the placeholder numbers
  // instead of leaving the demo values ("1,240", "Best Friend") on screen as if they were real.
  // (Editor preview keeps the placeholders by design — applyPaws early-returns on cfg.demo first.)
  function pawsNeutral() {
    $all('[data-pj-paws-balance]').forEach(function (e) { e.textContent = '—'; });
    $all('[data-pj-paws-tier]').forEach(function (e) { e.textContent = 'Member'; });
    $all('[data-pj-paws-nextline]').forEach(function (e) { e.style.display = 'none'; });
    $all('[data-pj-paws-progress]').forEach(function (e) { e.style.width = '0%'; });
  }
  function applyPaws() {
    if (cfg.demo) return;                                               // editor preview → keep static demo values
    if (!cfg.pawsLive || !cfg.pawsProxy || !cfg.customerId || !cfg.customerEmail || !cfg.pawsSig) {
      if (cfg.loggedIn) pawsNeutral();                                  // signed-in member but Paws off/unsigned → no fake numbers
      return;
    }
    fetch(cfg.pawsProxy, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: cfg.customerId, email: cfg.customerEmail, sig: cfg.pawsSig })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.loggedIn) { fillPaws(d); if (d.balance != null) { pawsBalance = Number(d.balance); refreshAfford(); } }
      else pawsNeutral();                                                // member not matched in the loyalty platform → no fake numbers
    }).catch(function () { pawsNeutral(); });                            // read failed → no fake numbers (never block render)
  }

  /* ---- Paws redemption (headless: our band UI, Influence does the deduction) ---- */
  var pawsBalance = null;
  function proxyBase() { return (cfg.pawsProxy || '').replace(/\/paws\/?$/, ''); }
  function htmlEsc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : s); return d.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }  // also escape quotes — htmlEsc feeds attribute contexts
  function rewardIcon(title, type) {
    var s = (String(title) + ' ' + String(type || '')).toLowerCase();
    if (/birthday/.test(s)) return '🎁';
    if (/dibs|early|exclusive/.test(s)) return '⚡';
    if (/vet|expert/.test(s)) return '🩺';
    if (/pawback|donat|meal|shelter/.test(s)) return '🏠';
    if (/coupon|discount|amount|off/.test(s)) return '💸';
    return '🐾';
  }
  function refreshAfford() {
    $all('[data-pj-redeem]').forEach(function (b) {
      var cost = Number(b.getAttribute('data-cost')) || 0;
      var lock = (pawsBalance == null) || (pawsBalance < cost);   // unknown balance → lock, don't fail open into an unaffordable redeem
      b.classList.toggle('is-locked', lock);
      if (lock) { b.setAttribute('aria-disabled', 'true'); } else { b.removeAttribute('aria-disabled'); }
      var lbl = b.getAttribute('data-label');           // card buttons swap to "Locked" when unaffordable
      if (lbl) b.textContent = lock ? 'Locked' : lbl;
    });
  }
  function rewardDesc(title) {                                          // "what you get" copy, keyed by reward name
    var t = String(title).toLowerCase();
    var ap = getActivePet(); var pet = (ap && ap.name) || 'your pet';
    if (/birthday/.test(t)) return 'A premium box of treats & toys, auto-timed to ' + pet + '’s special day.';
    if (/pawback|donat|meal|shelter/.test(t)) return 'Meals donated to an Aussie shelter — and we match a share on top.';
    if (/dibs|early|exclusive/.test(t)) return '24-hour early access to drops & restocks.';
    if (/vet|expert/.test(t)) return '1:1 session with a vet nutritionist or trainer.';
    if (/shipping/.test(t)) return 'Free express, next-day delivery on your next order.';
    if (/coupon|discount|amount|off/.test(t)) return 'Money off your next order — still here if you want it.';
    return '';
  }
  function rewardTileHtml(x, style) {
    var icon = rewardIcon(x.title, x.type);
    var attrs = 'data-pj-redeem="' + htmlEsc(x.id) + '" data-cost="' + (Number(x.points) || 0) + '" data-name="' + htmlEsc(x.title) + '"';
    if (style === 'card') {                                              // descriptive card (The Pack tab)
      var donate = /pawback|donat/i.test(x.title);
      var label = donate ? 'Donate' : 'Redeem';
      var desc = rewardDesc(x.title);
      return '<div class="pj-acct-card">' +
        '<div class="pj-acct-card-ico" aria-hidden="true">' + icon + '</div>' +
        '<div class="pj-acct-card-t gs">' + htmlEsc(x.title) + '</div>' +
        (desc ? '<div class="pj-acct-card-d">' + htmlEsc(desc) + '</div>' : '') +
        '<div class="pj-acct-card-f"><span class="pj-acct-card-c gs">' + formatPaws(x.points) + ' 🐾</span>' +
        '<button type="button" class="pj-acct-card-btn" ' + attrs + ' data-label="' + label + '">' + label + '</button></div></div>';
    }
    if (style === 'acct') {                                              // dark Pack panel inside the account modal
      return '<button type="button" class="pj-acct-rew" ' + attrs + '>' +
        '<span class="l"><span aria-hidden="true">' + icon + '</span> ' + htmlEsc(x.title) + '</span>' +
        '<span class="c">' + formatPaws(x.points) + '</span></button>';
    }
    return '<button type="button" class="qa pjh-redeem-tile" ' + attrs + '>' +              // home band tile
      '<span class="ico" aria-hidden="true">' + icon + '</span>' +
      '<div><div class="gs t">' + htmlEsc(x.title) + '</div><div class="v">' + formatPaws(x.points) + ' Paws</div></div></button>';
  }
  // Replace the account modal's "Loading your rewards…" placeholder with a real empty/error state on the
  // non-render paths (the home band keeps its static reward tiles, so it's left alone).
  function rewardsEmpty(msg) {
    $all('[data-pj-rewards]').forEach(function (grid) {
      if (!grid.closest('[data-pj-account-modal]')) return;
      grid.innerHTML = '<div class="pj-acct-rew-note">' + htmlEsc(msg) + '</div>';
    });
  }
  function applyRewards() {
    if (!cfg.pawsLive || !cfg.pawsProxy || cfg.demo) { rewardsEmpty('Rewards aren’t available right now.'); return; }
    if (!cfg.customerId || !cfg.customerEmail || !cfg.pawsSig) return;   // guest / unsigned → member modal isn't shown
    var grids = $all('[data-pj-rewards]');                               // band + account modal (one or more)
    if (!grids.length) return;
    fetch(proxyBase() + '/rewards', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var rewards = (d && d.rewards) || [];
        if (!rewards.length) { rewardsEmpty('No rewards to show just now.'); return; }   // empty catalog (band keeps static)
        grids.forEach(function (grid) {
          var style = grid.getAttribute('data-pj-rewards-style') || (grid.closest('[data-pj-account-modal]') ? 'acct' : 'band');
          grid.innerHTML = rewards.map(function (x) { return rewardTileHtml(x, style); }).join('');
        });
        refreshAfford();
      }).catch(function () { rewardsEmpty('Couldn’t load rewards just now — try again shortly.'); });
  }
  function showRedeemResult(name, coupon) {
    var real = coupon && coupon !== 'donation';
    var html = real
      ? '<b>' + htmlEsc(name) + ' redeemed!</b> Your code: <code>' + htmlEsc(coupon) + '</code> — save it for checkout.'
      : '<b>' + htmlEsc(name) + ' redeemed!</b> We’ll be in touch to sort it — keep an eye on your email.';
    $all('[data-pj-redeem-result]').forEach(function (b) { b.innerHTML = html; b.hidden = false; });
  }
  function redeemError() {
    $all('[data-pj-redeem-result]').forEach(function (b) { b.innerHTML = '<b>Couldn’t redeem just now.</b> Please try again in a moment.'; b.hidden = false; });
  }
  /* ---- modal focus management (a11y): move focus INTO the dialog on open, trap Tab inside the
     top-most layer, and restore focus to the opener on close. Escape closes only the TOP layer. ---- */
  var _focusStack = [];
  function modalFocusOpen(m) {
    if (!m) return;
    _focusStack.push(document.activeElement);
    if (!m.hasAttribute('tabindex')) m.setAttribute('tabindex', '-1');
    try { m.focus({ preventScroll: true }); } catch (e) { try { m.focus(); } catch (e2) {} }
  }
  function modalFocusClose() {
    var el = _focusStack.pop();
    if (el && el.focus && document.contains(el)) { try { el.focus({ preventScroll: true }); } catch (e) {} }
  }
  function topModal() {
    var c = document.querySelector('[data-pj-confirm].open'); if (c) return c;
    var a = document.querySelector('[data-pj-account-modal].open'); if (a) return a;
    var q = qModal(); if (q && !q.hidden) return q;
    return null;
  }

  var _confirmCb = null;
  function pjConfirm(msg, yesLabel, cb, sub) {
    var m = document.querySelector('[data-pj-confirm]');
    if (!m) { if (window.confirm(msg)) cb(); return; }                  // fallback if the modal isn't present
    var mt = m.querySelector('[data-pj-confirm-msg]'); if (mt) mt.textContent = msg;
    var st = m.querySelector('[data-pj-confirm-sub]');                  // context-specific sub-line (the Paws warning must not show on e.g. pet removal)
    if (st) { st.textContent = sub || ''; st.style.display = sub ? '' : 'none'; }
    var yb = m.querySelector('[data-pj-confirm-yes]'); if (yb) yb.textContent = yesLabel || 'Confirm';
    _confirmCb = cb;
    m.classList.add('open'); m.setAttribute('aria-hidden', 'false');
    modalFocusOpen(m);
  }
  function pjConfirmClose(run) {
    var m = document.querySelector('[data-pj-confirm]');
    var wasOpen = m && m.classList.contains('open');
    if (m) { m.classList.remove('open'); m.setAttribute('aria-hidden', 'true'); }
    if (wasOpen) modalFocusClose();
    var cb = _confirmCb; _confirmCb = null;
    if (run && cb) cb();
  }
  function doRedeem(btn) {
    if (btn.hasAttribute('disabled') || btn.getAttribute('aria-disabled') === 'true') return;
    var ruleId = btn.getAttribute('data-pj-redeem');
    var cost = Number(btn.getAttribute('data-cost')) || 0;
    var name = btn.getAttribute('data-name') || 'this reward';
    if (pawsBalance != null && pawsBalance < cost) return;
    var donate = /donat|pawback/i.test(name);
    pjConfirm((donate ? 'Donate “' : 'Redeem “') + name + '” for ' + formatPaws(cost) + ' Paws?', donate ? 'Donate' : 'Redeem', function () {
      btn.setAttribute('disabled', 'disabled');
      fetch(proxyBase() + '/redeem', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: cfg.customerId, email: cfg.customerEmail, sig: cfg.pawsSig, ruleId: ruleId })
      }).then(function (r) { return r.json(); }).then(function (res) {
        btn.removeAttribute('disabled');
        if (res && res.ok && res.success) {
          if (pawsBalance != null) { pawsBalance -= cost; fillPaws({ balance: pawsBalance }); }
          refreshAfford();
          showRedeemResult(name, res.couponCode);
          setTimeout(function () { applyCodes(true); }, 2000);          // a coupon redeem mints a discount code → refresh "Your codes" (fresh = skip the proxy cache; 2s for Shopify to materialise it)
          toast();
        } else { redeemError(); }
      }).catch(function () { btn.removeAttribute('disabled'); redeemError(); });
    }, 'Paws are spent instantly and can’t be undone.');
  }

  /* ---- Account dashboard modal (signed-in members) ---- */
  function renderAccountPets() {
    var box = document.querySelector('[data-pj-account-pets]');
    if (!box) return;
    if (!cfg.petsList || !cfg.petsList.length) {
      // e.g. the member just removed their last pet — swap the stale card for the empty state
      // (mirrors the Liquid default so the pane never shows a deleted pet).
      box.innerHTML = '<p class="pj-acct-empty">No pets yet — add one to tailor the shop.</p>';
      return;
    }
    var active = getActivePet();
    box.innerHTML = cfg.petsList.map(function (p, i) {
      var bits = [p.species, p.stage, p.size].filter(Boolean).join(' · ');
      var on = active && p.name === active.name;
      var nm = htmlEsc(p.name || 'Unnamed');
      return '<div class="pj-acct-petcard' + (on ? ' is-shopping' : '') + '">' +
        '<div class="pj-acct-pethd">' +
          '<span class="pj-acct-petava" aria-hidden="true">' + speciesEmoji(p.species, p.stage) + '</span>' +
          '<div class="pj-acct-petmeta"><div class="pn gs">' + nm + '</div><div class="pd">' + htmlEsc(bits) + '</div></div>' +
          (p.primary ? '<span class="pp">Primary</span>' : '') +
        '</div>' +
        '<div class="pj-acct-petacts">' +
          (on
            ? '<span class="pj-acct-petactive">✓ Shopping for ' + nm + '</span>'
            : '<button type="button" class="pj-acct-petbtn" data-pj-setactive="' + htmlEsc(p.name) + '">Shop for ' + nm + '</button>') +
          '<span class="pj-acct-petacts-right">' +
            '<button type="button" class="pj-acct-petedit" data-pj-pet-edit="' + i + '">Edit</button>' +
            '<button type="button" class="pj-acct-petremove" data-pj-pet-remove="' + i + '">Remove</button>' +
          '</span>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  /* ---- Your codes: this member's own unused discount codes (tps-services /codes) ---- */
  function applyCodes(fresh) {
    var sec = document.querySelector('[data-pj-codes-sec]');
    var box = document.querySelector('[data-pj-codes]');
    if (!sec || !box) return;
    if (!cfg.pawsLive || !cfg.pawsProxy || cfg.demo) return;             // off / preview → stays hidden
    if (!cfg.customerId || !cfg.customerEmail || !cfg.pawsSig) return;   // guest / unsigned → stays hidden
    fetch(proxyBase() + '/codes', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: cfg.customerId, email: cfg.customerEmail, sig: cfg.pawsSig, fresh: !!fresh })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (!d || !Array.isArray(d.codes) || !d.codes.length) { sec.hidden = true; return; }
      box.innerHTML = d.codes.map(function (c) {
        var rawSum = (c.summary || '').split('• For')[0].trim();   // drop the "• For <name>" tail — redundant on the member's own dashboard
        var sum = rawSum ? htmlEsc(rawSum) : (c.title ? htmlEsc(c.title) : 'Discount');
        return '<button type="button" class="pj-acct-code" data-pj-copycode="' + htmlEsc(c.code) + '">' +
          '<span class="pj-acct-code-l"><span class="pj-acct-code-v gs">' + htmlEsc(c.code) + '</span>' +
          '<span class="pj-acct-code-d">' + sum + '</span></span>' +
          '<span class="pj-acct-code-copy">Copy</span></button>';
      }).join('');
      sec.hidden = false;
    }).catch(function () {});
  }
  function copyCode(btn) {
    var code = btn.getAttribute('data-pj-copycode') || '';
    var lbl = btn.querySelector('.pj-acct-code-copy');
    function feedback() {
      btn.classList.add('is-copied');
      if (lbl) lbl.textContent = 'Copied — use at checkout';
      setTimeout(function () { btn.classList.remove('is-copied'); if (lbl) lbl.textContent = 'Copy'; }, 2600);
    }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(feedback, feedback); }
      else {
        var t = document.createElement('textarea'); t.value = code; t.style.position = 'fixed'; t.style.opacity = '0';
        document.body.appendChild(t); t.focus(); t.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(t); feedback();
      }
    } catch (e) { feedback(); }
  }

  /* ---- in-account pet editor (add/edit/remove via tps-services /pets) ---- */
  function petFormEl() { return document.querySelector('[data-pj-pet-form]'); }
  function petFormMsg(text, ok) {
    var m = document.querySelector('[data-pj-pet-form-msg]');
    if (!m) return;
    if (!text) { m.hidden = true; m.textContent = ''; return; }
    m.hidden = false; m.textContent = text; m.className = 'pj-acct-petform-msg' + (ok ? ' is-ok' : '');
  }
  function petField(k) { var f = petFormEl(); return f ? f.querySelector('[data-pj-pf="' + k + '"]') : null; }
  function openPetForm(pet) {
    var f = petFormEl(); if (!f) return;
    petFormMsg('');
    var set = function (k, v) { var el = petField(k); if (el) el.value = v; };
    set('id', pet ? (pet.id || '') : '');
    set('name', pet ? (pet.name || '') : '');
    set('species', pet ? (pet.species || 'Dog') : 'Dog');
    set('life_stage', pet ? (pet.stage || 'Adult') : 'Adult');
    set('breed_size', pet ? (pet.size || 'Medium') : 'Medium');
    set('birthday', pet ? (pet.birthday || '') : '');
    set('dietary', pet ? (Array.isArray(pet.dietary) ? (pet.dietary[0] || '') : (pet.dietary || '')) : '');
    var title = f.querySelector('[data-pj-pet-form-title]'); if (title) title.textContent = pet ? ('Edit ' + (pet.name || 'pet')) : 'Add a pet';
    f.hidden = false;
    var nmI = petField('name'); if (nmI) { try { nmI.focus(); } catch (e) {} }
    try { f.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {}
  }
  function closePetForm() { var f = petFormEl(); if (f) f.hidden = true; petFormMsg(''); }
  function petAuthReady() { return cfg.pawsProxy && cfg.customerId && cfg.customerEmail && cfg.pawsSig; }
  function petAction(action, payload, onDone) {
    if (!petAuthReady()) { petFormMsg('You need to be signed in (with Paws on) to edit pets here — or manage them on Shopify.'); return; }
    fetch(proxyBase() + '/pets', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: cfg.customerId, email: cfg.customerEmail, sig: cfg.pawsSig, action: action, pet: payload })
    }).then(function (r) { return r.json().catch(function () { return { ok: false }; }); }).then(function (d) {
      if (d && d.enabled === false) { petFormMsg('In-account pet editing isn’t switched on yet — you can manage pets on Shopify below.'); var hl = document.querySelector('[data-pj-pet-hostlink]'); if (hl) hl.style.display = 'inline-block'; return; }
      if (!d || !d.ok || !Array.isArray(d.pets)) { petFormMsg('Sorry — that didn’t save. Please try again.'); return; }
      cfg.petsList = d.pets.map(mapPetShape).filter(function (p) { return p.name; });
      var act = activePetName();
      if (act && !cfg.petsList.some(function (p) { return p.name === act; })) { try { localStorage.removeItem('tps_active_pet'); } catch (e) {} }
      applyPersonalization(); renderPetSwitch(); renderAccountPets();
      if (onDone) onDone();
    }).catch(function () { petFormMsg('Network error — please try again.'); });
  }
  function submitPetForm() {
    var f = petFormEl(); if (!f) return;
    var val = function (k) { var el = petField(k); return el ? el.value : ''; };
    var name = (val('name') || '').trim();
    if (!name) { petFormMsg('Please enter a name.'); return; }
    var pid = val('id');
    var diet = (val('dietary') || '').trim();
    var payload = { name: name, species: val('species'), life_stage: val('life_stage'), breed_size: val('breed_size'), birthday: val('birthday'),
      dietary: diet ? [diet] : [] };
    if (pid) payload.id = pid;
    var save = f.querySelector('[data-pj-pet-save]'); if (save) save.disabled = true;
    petFormMsg('Saving…', true);
    petAction(pid ? 'edit' : 'add', payload, function () { closePetForm(); });
    setTimeout(function () { if (save) save.disabled = false; }, 2500);
  }
  function removePet(pet) {
    if (!pet) return;
    var nm = pet.name || 'this pet';
    pjConfirm('Remove ' + nm + '’s profile? This can’t be undone.', 'Remove', function () { petAction('remove', { id: pet.id }, null); });
  }
  // Researched dry-food daily intake (grams/day) by species + size — tunable estimate.
  function dailyGrams(species, size) {
    var sp = String(species || '').toLowerCase(), sz = String(size || '').toLowerCase();
    var isCat = sp.indexOf('cat') >= 0;
    var t = isCat ? { small: 45, medium: 60, large: 75 } : { small: 120, medium: 250, large: 350 };
    return t[sz] || (isCat ? 60 : 250);
  }
  function foodDueIn(food, species, size) {
    var m = String(food.variant || '').match(/(\d+(?:\.\d+)?)\s*kg/i);
    if (!m) return { label: 'Reorder when you’re low', due: null };
    var days = (parseFloat(m[1]) * 1000) / dailyGrams(species, size);
    var since = food.date ? (Date.now() / 1000 - Number(food.date)) / 86400 : 0;
    var due = Math.round(days - since);
    if (due <= 0) return { label: 'Likely run out — restock', due: due };
    return { label: 'Due in ~' + due + ' day' + (due === 1 ? '' : 's'), due: due };
  }
  function essBlock(item, sub, btnLabel) {
    var img = item.img ? '<img src="' + item.img + '" alt="" class="pj-acct-ess-img">' : '<div class="pj-acct-ess-img"></div>';
    var add = item.vid ? '<button type="button" class="pj-acct-ess-add" data-pj-add="' + htmlEsc(item.vid) + '" aria-label="' + htmlEsc(btnLabel) + '">+</button>' : '';
    return '<div class="pj-acct-ess-card">' + img +
      '<div class="pj-acct-ess-b"><div class="pj-acct-ess-t gs">' + htmlEsc(item.title) + '</div>' +
      '<div class="pj-acct-ess-s">' + htmlEsc(sub) + '</div></div>' + add + '</div>';
  }
  function renderEssentials() {
    var node = document.querySelector('[data-pj-essentials]');
    var grid = document.querySelector('[data-pj-essentials-grid]');
    if (!node || !grid) return;
    var d; try { d = JSON.parse(node.textContent); } catch (e) { return; }
    var pet = d.pet || 'your pet';
    var blocks = [];
    if (d.food) blocks.push(essBlock(d.food, foodDueIn(d.food, d.species, d.size).label, 'Restock ' + d.food.title));
    if (d.treat) blocks.push(essBlock(d.treat, 'Has ' + pet + ' run out?', 'Reorder ' + d.treat.title));
    if (d.rec) blocks.push(essBlock(d.rec, 'We think ' + pet + ' would love this', 'Add ' + d.rec.title));
    if (blocks.length) grid.innerHTML = blocks.join('');
    var rk = document.querySelector('[data-pj-restock]');
    if (rk) {
      rk.innerHTML = '';
      if (d.food) {
        var info = foodDueIn(d.food, d.species, d.size);
        if (info.due != null && info.due <= 10) {
          rk.innerHTML = '<div class="pj-acct-restock"><span class="i" aria-hidden="true">⏰</span>' +
            '<div class="t"><b>Is ' + htmlEsc(pet) + ' running low?</b><br>' + htmlEsc(d.food.title) + ' is ' +
            (info.due <= 0 ? 'likely run out' : 'due in ~' + info.due + ' days') + ' — restock to keep the good stuff coming.</div>' +
            '<button type="button" class="pj-acct-restock-b" data-pj-add="' + htmlEsc(d.food.vid) + '">Restock</button></div>';
        }
      }
    }
  }
  function setAcctTab(tab) {
    $all('[data-pj-acct-pane]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-pj-acct-pane') === tab); });
    $all('.pj-acct-navi[data-pj-acct-tab]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-pj-acct-tab') === tab); });
  }
  function openAccount() {
    var m = document.querySelector('[data-pj-account-modal]');
    if (!m) return;
    renderAccountPets();
    renderEssentials();
    applyPaws();                                                       // refresh balance/tier on open (avoid stale)
    applyCodes();                                                      // this member's own discount codes
    m.classList.add('open'); m.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    modalFocusOpen(m);
  }
  function closeAccount() {
    var m = document.querySelector('[data-pj-account-modal]');
    if (!m) return;
    var wasOpen = m.classList.contains('open');
    m.classList.remove('open'); m.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (wasOpen) modalFocusClose();
  }

  /* ---- cart ---- */
  function setCount(n) { $all('[data-pj-cartcount]').forEach(function (e) { e.textContent = n; }); var d = document.querySelector('[data-pj-drawer-count]'); if (d) d.textContent = n; }
  function openCart() { var d = document.querySelector('[data-pj-drawer]'), s = document.querySelector('[data-pj-scrim]'); if (d) d.classList.add('open'); if (s) s.classList.add('open'); render(); }
  function closeCart() { var d = document.querySelector('[data-pj-drawer]'), s = document.querySelector('[data-pj-scrim]'); if (d) d.classList.remove('open'); if (s) s.classList.remove('open'); }

  function render() {
    return fetch(cfg.cartUrl + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      setCount(cart.item_count);
      var sub = document.querySelector('[data-pj-subtotal]'); if (sub) sub.textContent = money(cart.total_price);
      var bar = document.querySelector('[data-pj-ship-bar]'), msg = document.querySelector('[data-pj-ship-msg]');
      if (bar && msg && cfg.threshold > 0) {
        var pct = Math.min(100, Math.round(cart.total_price / cfg.threshold * 100));
        bar.style.width = pct + '%';
        if (cart.total_price >= cfg.threshold) { msg.innerHTML = "✓ You've unlocked free metro shipping (SA, VIC & NSW)"; msg.style.color = '#2E7D54'; bar.style.background = '#2E7D54'; }
        else { msg.innerHTML = "You're <span style=\"color:#5C4295;\">" + money(cfg.threshold - cart.total_price) + "</span> away from free metro shipping (SA, VIC & NSW)"; msg.style.color = '#43306E'; bar.style.background = '#5C4295'; }
      }
      var wrap = document.querySelector('[data-pj-lines]'); if (!wrap) return cart;
      wrap.innerHTML = '';
      if (!cart.items.length) { wrap.innerHTML = '<div style="text-align:center;color:#7A6E96;padding:40px 0;font-size:14px;">Your cart is empty.</div>'; return cart; }
      cart.items.forEach(function (it) {
        var d = document.createElement('div');
        d.style.cssText = 'display:flex;gap:13px;padding:13px;background:#fff;border:1px solid #E4DAF2;border-radius:12px;margin-bottom:12px;';
        var img = it.image ? '<img src="' + it.image + '" alt="" style="width:62px;height:62px;border-radius:9px;object-fit:cover;flex:none;border:1px solid #EFE7FB;">' : '<div style="width:62px;height:62px;border-radius:9px;flex:none;border:1px solid #EFE7FB;background:#F4ECFD;"></div>';
        d.innerHTML = img +
          '<div style="flex:1;min-width:0;">' +
            '<div style="font-size:11px;font-weight:600;color:#9A91B0;text-transform:uppercase;letter-spacing:.04em;">' + (it.vendor || '') + '</div>' +
            '<div class="gs" style="font-size:14px;font-weight:600;color:#241B3A;line-height:1.25;">' + it.product_title + '</div>' +
            (it.variant_title ? '<div style="font-size:12px;color:#7A6E96;margin:2px 0 8px;">' + it.variant_title + '</div>' : '<div style="height:6px;"></div>') +
            '<div style="display:flex;align-items:center;justify-content:space-between;">' +
              '<div style="display:flex;align-items:center;border:1px solid #E4DAF2;border-radius:7px;overflow:hidden;">' +
                '<button data-line="' + it.key + '" data-q="' + (it.quantity - 1) + '" class="pj-qa-line" style="width:28px;height:28px;background:#fff;border:none;color:#43306E;cursor:pointer;font-size:16px;">−</button>' +
                '<span style="width:30px;text-align:center;font-size:13px;font-weight:600;color:#241B3A;">' + it.quantity + '</span>' +
                '<button data-line="' + it.key + '" data-q="' + (it.quantity + 1) + '" class="pj-qa-line" style="width:28px;height:28px;background:#fff;border:none;color:#43306E;cursor:pointer;font-size:16px;">+</button>' +
              '</div>' +
              '<span class="gs" style="font-size:15px;font-weight:600;color:#241B3A;">' + money(it.final_line_price) + '</span>' +
            '</div>' +
          '</div>';
        wrap.appendChild(d);
      });
      wrap.querySelectorAll('.pj-qa-line').forEach(function (btn) {
        btn.addEventListener('click', function () { changeLine(btn.getAttribute('data-line'), parseInt(btn.getAttribute('data-q'), 10)); });
      });
      return cart;
    }).catch(function () { return null; });
  }
  function changeLine(key, qty) {
    return fetch(cfg.cartChangeUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) })
      .then(function (r) { return r.json(); }).then(function () { return render(); });
  }
  function addToCart(id, qty, sellingPlan) {
    var body = { id: parseInt(id, 10), quantity: qty || 1 };
    if (sellingPlan) { body.selling_plan = parseInt(sellingPlan, 10); }
    return fetch(cfg.cartAddUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) {
        return r.json().then(function (res) {
          // /cart/add.js returns HTTP 422 (with a JSON error body) on out-of-stock / over-available-qty /
          // sell-out races. fetch does NOT reject on 4xx, so guard r.ok before treating this as success —
          // otherwise a failed add silently dispatches cart:refresh and opens the drawer with the cart unchanged.
          if (!r.ok) { var err = new Error((res && (res.description || res.message)) || 'Could not add to cart'); err.cartError = res; throw err; }
          // Legacy bespoke drawer (not present on Hyper) — keep working if it ever exists.
          if (document.querySelector('[data-pj-drawer]')) {
            return render().then(function () { openCart(); toast(); return res; });
          }
          // Hyper native cart: refresh + open the theme's own <cart-drawer> and update
          // the header count badge (it subscribes to FoxTheme cartUpdate via this event).
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
          return res;
        });
      });
  }

  var toastT;
  function toast() {
    var t = document.querySelector('[data-pj-toast]'); if (!t) return;
    t.classList.remove('pj-hide'); t.style.display = 'flex';
    clearTimeout(toastT); toastT = setTimeout(function () { t.style.display = 'none'; t.classList.add('pj-hide'); }, 2200);
  }
  // Self-contained fallback toast for surfacing quick-add failures (e.g. sold-out 422) that would
  // otherwise be silent — the bespoke [data-pj-toast] element isn't present on Hyper.
  function pjToast(msg) {
    try {
      var el = document.createElement('div');
      el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
      el.textContent = msg;
      el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:9999;background:#43306E;color:#fff;font-family:inherit;font-size:14px;font-weight:600;line-height:1.3;padding:12px 18px;border-radius:12px;box-shadow:0 10px 30px rgba(67,48,110,.3);max-width:88vw;text-align:center;';
      document.body.appendChild(el);
      setTimeout(function () { el.style.transition = 'opacity .3s'; el.style.opacity = '0'; setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 320); }, 3200);
    } catch (e) {}
  }

  /* ---- Fit Quiz ---- */
  var quiz = { answers: {}, order: ['species'], idx: 0 };

  function qModal() { return document.querySelector('[data-pj-quiz-modal]'); }
  function buildOrder(species) {
    if (species === 'Dog') return ['species', 'stage', 'size', 'dietary', 'name', 'email'];
    if (species === 'Cat') return ['species', 'stage', 'dietary', 'name', 'email'];
    if (species === 'Fish' || species === 'Bird' || species === 'Small Animal' || species === 'Reptile') return ['species', 'type', 'name', 'email'];
    return ['species', 'name', 'email'];
  }
  var SP_WORD = { Dog: 'dog', Cat: 'cat', Fish: 'fish', Bird: 'bird', 'Small Animal': 'small pet', Reptile: 'reptile', Horse: 'horse' };
  function fillQuizNames() {
    var m = qModal(); if (!m) return;
    var nm = quiz.answers.name || 'your pet';
    Array.prototype.slice.call(m.querySelectorAll('[data-pj-quiz-name]')).forEach(function (e) { e.textContent = nm; });
  }
  function setProgress(pct) { var b = qModal() && qModal().querySelector('[data-pj-quiz-progress]'); if (b) b.style.width = pct + '%'; }
  function showStep(i) {
    var m = qModal(); if (!m) return;
    quiz.idx = i;
    var name = quiz.order[i];
    Array.prototype.slice.call(m.querySelectorAll('[data-pj-step]')).forEach(function (s) { s.hidden = s.getAttribute('data-pj-step') !== name; });
    var total = quiz.order.length > 1 ? quiz.order.length : 6;
    setProgress(Math.round((i + 1) / total * 100));
    var back = m.querySelector('[data-pj-back]'); if (back) back.hidden = (i === 0);
    fillQuizNames();
    if (name === 'name' || name === 'email') {
      var inp = m.querySelector('[data-pj-step="' + name + '"] input');
      if (inp) setTimeout(function () { inp.focus(); }, 60);
    } else {
      // Move focus into the newly shown step so keyboard/SR users aren't dropped to <body>
      // when the option they clicked is hidden as the step advances.
      var stepEl = m.querySelector('[data-pj-step="' + name + '"]');
      if (stepEl) setTimeout(function () { stepEl.setAttribute('tabindex', '-1'); try { stepEl.focus(); } catch (e) {} }, 60);
    }
  }
  function nextStep() { if (quiz.idx < quiz.order.length - 1) showStep(quiz.idx + 1); }
  function prevStep() { if (quiz.idx > 0) showStep(quiz.idx - 1); }
  function filterStageOptions(species) {
    var m = qModal(); if (!m) return;
    Array.prototype.slice.call(m.querySelectorAll('[data-pj-step="stage"] [data-pj-opt]')).forEach(function (o) {
      var f = o.getAttribute('data-for');
      o.hidden = !!f && f !== species;
    });
  }
  function filterTypeOptions(species) {
    var m = qModal(); if (!m) return;
    Array.prototype.slice.call(m.querySelectorAll('[data-pj-step="type"] [data-pj-opt]')).forEach(function (o) {
      o.hidden = o.getAttribute('data-for') !== species;
    });
  }
  function quizMsg(text, ok) {
    var m = qModal() && qModal().querySelector('[data-pj-quiz-msg]'); if (!m) return;
    m.textContent = text; m.style.display = ''; m.style.color = ok ? '#2E7D54' : '#C2452D';
  }
  function openQuiz() {
    var m = qModal();
    if (!m) { if (cfg.klaviyoForm) { window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', cfg.klaviyoForm]); return; } window.location.href = cfg.registerUrl; return; }
    quiz = { answers: {}, order: ['species'], idx: 0 };
    Array.prototype.slice.call(m.querySelectorAll('[data-pj-opt]')).forEach(function (b) { b.classList.remove('sel'); });
    var ni = m.querySelector('[data-pj-field="name"]'), ei = m.querySelector('[data-pj-field="email"]'), oi = m.querySelector('[data-pj-field="owner"]'); if (ni) ni.value = ''; if (ei) ei.value = ''; if (oi) oi.value = '';
    var msg = m.querySelector('[data-pj-quiz-msg]'); if (msg) msg.style.display = 'none';
    var sb = m.querySelector('[data-pj-submit]'); if (sb) { sb.disabled = false; if (sb.getAttribute('data-orig-label')) sb.textContent = sb.getAttribute('data-orig-label'); }
    m.hidden = false; document.body.style.overflow = 'hidden';
    modalFocusOpen(m);
    showStep(0);
  }
  function closeQuiz() { var m = qModal(); var wasOpen = m && !m.hidden; if (m) m.hidden = true; document.body.style.overflow = ''; if (wasOpen) modalFocusClose(); }

  function klaviyoWrite(email, props, optin, owner) {
    var key = cfg.klaviyoKey; if (!key) return Promise.resolve();
    var headers = { 'Content-Type': 'application/json', 'revision': '2024-10-15' };
    var attrs = { email: email, properties: props };
    if (owner) attrs.first_name = owner;
    var calls = [fetch('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(key), {
      method: 'POST', headers: headers,
      body: JSON.stringify({ data: { type: 'profile', attributes: attrs } })
    })];
    if (optin && cfg.emailList) {
      calls.push(fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
        method: 'POST', headers: headers,
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Fit Quiz', profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: cfg.emailList } } } } })
      }));
    }
    return Promise.all(calls);
  }
  function submitQuiz() {
    var m = qModal(); if (!m) return;
    var ei = m.querySelector('[data-pj-field="email"]');
    var email = ((ei && ei.value) || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { quizMsg('Please enter a valid email address.', false); if (ei) ei.focus(); return; }
    quiz.answers.email = email;
    var optin = m.querySelector('[data-pj-optin]'); optin = optin ? optin.checked : false;
    var btn = m.querySelector('[data-pj-submit]'); if (btn) { if (!btn.getAttribute('data-orig-label')) btn.setAttribute('data-orig-label', btn.textContent); btn.disabled = true; btn.textContent = 'Saving…'; }
    var props = {
      pet_name: quiz.answers.name || '', pet_species: quiz.answers.species || '',
      pet_animal_type: quiz.answers.animal_type || '',
      pet_life_stage: quiz.answers.life_stage || '', pet_breed_size: quiz.answers.breed_size || '',
      pet_dietary: quiz.answers.dietary || ''
    };
    var owner = quiz.answers.owner || '';
    try { localStorage.setItem('tps_pet', JSON.stringify({ name: props.pet_name, owner: owner, species: props.pet_species, type: props.pet_animal_type, stage: props.pet_life_stage, size: props.pet_breed_size, dietary: props.pet_dietary })); } catch (e) {}
    try { if (window.klaviyo && window.klaviyo.identify) { window.klaviyo.identify({ '$email': email, '$first_name': owner, pet_name: props.pet_name, pet_species: props.pet_species, pet_animal_type: props.pet_animal_type, pet_life_stage: props.pet_life_stage, pet_breed_size: props.pet_breed_size, pet_dietary: props.pet_dietary }); } } catch (e) {}
    var finish = function () { setView('member'); showDone(); };
    klaviyoWrite(email, props, optin, owner).then(finish).catch(function (err) {
      // Pet is already saved locally (personalisation works); surface the capture failure so
      // silently-lost leads are visible in UAT instead of always reporting success.
      try { console.warn('[PJ] Fit Quiz: Klaviyo capture failed — pet saved locally, email lead may not be recorded:', err); } catch (e2) {}
      finish();
    });
  }
  function showDone() {
    var m = qModal(); if (!m) return;
    Array.prototype.slice.call(m.querySelectorAll('[data-pj-step]')).forEach(function (s) { s.hidden = s.getAttribute('data-pj-step') !== 'done'; });
    setProgress(100);
    var back = m.querySelector('[data-pj-back]'); if (back) back.hidden = true;
    fillQuizNames();
  }

  function bindQuiz() {
    var m = qModal(); if (!m) return;
    m.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-pj-opt]');
      if (opt && m.contains(opt)) {
        var field = opt.getAttribute('data-field'), val = opt.getAttribute('data-val');
        quiz.answers[field] = val;
        var step = opt.closest('[data-pj-step]');
        Array.prototype.slice.call(step.querySelectorAll('[data-pj-opt]')).forEach(function (o) { o.classList.remove('sel'); });
        opt.classList.add('sel');
        if (field === 'species') { quiz.order = buildOrder(val); filterStageOptions(val); filterTypeOptions(val); var spn = m.querySelector('[data-pj-quiz-species]'); if (spn) { spn.textContent = SP_WORD[val] || 'pet'; } }
        fillQuizNames();
        if (quiz._adv) clearTimeout(quiz._adv);           // coalesce rapid double-clicks so we never skip a step
        quiz._adv = setTimeout(nextStep, 200);
        return;
      }
      if (e.target.closest('[data-pj-quiz-close]') || e.target.closest('[data-pj-quiz-scrim]')) { closeQuiz(); return; }
      if (e.target.closest('[data-pj-back]')) { prevStep(); return; }
      if (e.target.closest('[data-pj-next]')) {
        var ni = m.querySelector('[data-pj-field="name"]'); var v = ((ni && ni.value) || '').trim();
        if (!v) { if (ni) ni.focus(); return; }
        var oi = m.querySelector('[data-pj-field="owner"]'); quiz.answers.owner = ((oi && oi.value) || '').trim();
        quiz.answers.name = v; fillQuizNames(); nextStep(); return;
      }
      if (e.target.closest('[data-pj-submit]')) { submitQuiz(); return; }
    });
    m.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var step = quiz.order[quiz.idx];
      if (step === 'name') { e.preventDefault(); var nb = m.querySelector('[data-pj-next]'); if (nb) nb.click(); }
      else if (step === 'email') { e.preventDefault(); submitQuiz(); }
    });
  }

  function bind() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-pj-member],[data-pj-guest],[data-pj-cart-open],[data-pj-cart-close],[data-pj-scrim],[data-pj-add],[data-pj-quiz],[data-pj-redeem],[data-pj-account],[data-pj-account-close],[data-pj-acct-tab],[data-pj-setactive],[data-pj-pet-add],[data-pj-pet-edit],[data-pj-pet-remove],[data-pj-pet-cancel],[data-pj-copycode],[data-pj-cross-cta],[data-pj-confirm-yes],[data-pj-confirm-no],[data-pj-login]');
      if (!t) return;
      if (t.hasAttribute('data-pj-member')) { setView('member'); }
      else if (t.hasAttribute('data-pj-guest')) { setView('guest'); }
      else if (t.hasAttribute('data-pj-cart-open')) { openCart(); }
      else if (t.hasAttribute('data-pj-cart-close') || t.hasAttribute('data-pj-scrim')) { closeCart(); }
      else if (t.hasAttribute('data-pj-quiz')) { e.preventDefault(); openQuiz(); }
      else if (t.hasAttribute('data-pj-add')) {
        e.preventDefault();
        t.setAttribute('disabled', 'disabled');
        addToCart(t.getAttribute('data-pj-add'), 1, t.getAttribute('data-pj-selling-plan')).then(function () { t.removeAttribute('disabled'); }).catch(function (err) { t.removeAttribute('disabled'); pjToast((err && err.message) || 'Sorry — we couldn’t add that to your cart. Please try again.'); });
      }
      else if (t.hasAttribute('data-pj-redeem')) { e.preventDefault(); doRedeem(t); }
      else if (t.hasAttribute('data-pj-account')) { e.preventDefault(); openAccount(); var acctTab = t.getAttribute('data-pj-acct-open'); if (acctTab) setAcctTab(acctTab); }
      else if (t.hasAttribute('data-pj-login')) {
        // Guest join CTAs open the same Shopify sign-in sheet as the header account icon
        // (the <shopify-account> web component's public showModal()). Shopify only enhances
        // the header icon automatically, so plain /account/login links elsewhere would
        // full-page to the hosted login. Fallback: if the sheet did not open (component
        // missing/blocked), follow the link normally after a beat.
        var sa = document.querySelector('shopify-account');
        if (sa && typeof sa.showModal === 'function') {
          e.preventDefault();
          var loginHref = t.getAttribute('href');
          sa.showModal();
          setTimeout(function () {
            var saOpen = sa.shadowRoot && sa.shadowRoot.querySelector('dialog[open]');
            if (!saOpen && loginHref) window.location.href = loginHref;
          }, 700);
        }
      }
      else if (t.hasAttribute('data-pj-account-close')) { closeAccount(); }
      else if (t.hasAttribute('data-pj-acct-tab')) { setAcctTab(t.getAttribute('data-pj-acct-tab')); }
      else if (t.hasAttribute('data-pj-setactive')) { e.preventDefault(); setActivePet(t.getAttribute('data-pj-setactive')); }
      else if (t.hasAttribute('data-pj-pet-add')) { e.preventDefault(); openPetForm(null); }
      else if (t.hasAttribute('data-pj-pet-edit')) { e.preventDefault(); openPetForm((cfg.petsList || [])[parseInt(t.getAttribute('data-pj-pet-edit'), 10)] || null); }
      else if (t.hasAttribute('data-pj-pet-remove')) { e.preventDefault(); removePet((cfg.petsList || [])[parseInt(t.getAttribute('data-pj-pet-remove'), 10)] || null); }
      else if (t.hasAttribute('data-pj-pet-cancel')) { e.preventDefault(); closePetForm(); }
      else if (t.hasAttribute('data-pj-copycode')) { e.preventDefault(); copyCode(t); }
      else if (t.hasAttribute('data-pj-cross-cta')) {
        // "Add them to your Pack": signed-in members → the account pet editor; quiz-guests → the Fit Quiz.
        e.preventDefault();
        if (cfg.loggedIn) { openAccount(); setAcctTab('pets'); } else { openQuiz(); }
      }
      else if (t.hasAttribute('data-pj-confirm-yes')) { pjConfirmClose(true); }
      else if (t.hasAttribute('data-pj-confirm-no')) { pjConfirmClose(false); }
    });
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-pj-pet-form]')) { e.preventDefault(); submitPetForm(); }
    });
    // In-page anchors ("Shop all dog" → #pj-shop-all, "Read reviews" → #pj-reviews) get a QUICK eased
    // scroll instead of the browser's instant teleport — the motion tells the shopper they're still on
    // the same page. Duration scales a little with distance (350–650ms) so it always feels fast.
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;   // let modifier-clicks (open in new tab etc.) behave natively
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      var headerOffset = 96;
      var sm = parseFloat(getComputedStyle(target).scrollMarginTop);
      if (sm > 0) headerOffset = sm;
      var destY = Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - headerOffset);
      try { history.pushState(null, '', '#' + id); } catch (err) {}
      // a11y: move keyboard focus to the target so the skip-to-content link + in-page anchors work
      // for keyboard/screen-reader users, not just a visual scroll (WCAG 2.4.1).
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      try { target.focus({ preventScroll: true }); } catch (err2) {}
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { window.scrollTo(0, destY); return; }
      var startY = window.pageYOffset, dist = destY - startY;
      if (!dist) return;
      var dur = Math.max(350, Math.min(650, Math.abs(dist) * 0.35));
      var t0 = null, done = false;
      function ease(p) { return p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; }  // easeInOutCubic
      function step(ts) {
        if (done) return;
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        window.scrollTo(0, startY + dist * ease(p));
        if (p < 1) requestAnimationFrame(step); else done = true;
      }
      requestAnimationFrame(step);
      // Watchdog: rAF pauses in hidden/backgrounded tabs — guarantee the shopper still lands at the target.
      setTimeout(function () { if (!done) { done = true; window.scrollTo(0, destY); } }, dur + 400);
    });
    document.addEventListener('click', function (e) {
      var tog = e.target.closest('[data-pj-petswitch-toggle]');
      if (tog) { if (switchPets().length) { e.preventDefault(); togglePetSwitch(); } return; }
      if (!e.target.closest('[data-pj-petswitch-wrap]')) { closePetSwitch(); }
    });
    // Escape closes only the TOP open layer (confirm > account > quiz > cart > pet switcher),
    // and Tab is trapped inside the top-most dialog while one is open.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') {
        var tm = topModal(); if (!tm) return;
        var f = tm.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
        var vis = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
        if (!vis.length) { e.preventDefault(); return; }
        var first = vis[0], last = vis[vis.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === tm)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        return;
      }
      if (e.key === 'Escape') {
        var c = document.querySelector('[data-pj-confirm].open'); if (c) { pjConfirmClose(false); return; }
        var a = document.querySelector('[data-pj-account-modal].open'); if (a) { closeAccount(); return; }
        var q = qModal(); if (q && !q.hidden) { closeQuiz(); return; }
        var d = document.querySelector('[data-pj-drawer].open'); if (d) { closeCart(); return; }
        closePetSwitch();
      }
      if (e.key === '/' && document.activeElement && document.activeElement.tagName !== 'INPUT' && document.activeElement.tagName !== 'TEXTAREA') {
        var inp = document.querySelector('input[name="q"], input[type="search"]'); if (inp) { e.preventDefault(); inp.focus(); }
      }
    });
  }

  // Re-personalise product cards after the collection grid is re-rendered client-side.
  // Hyper's facets replace #ProductGridContainer's HTML on filter change (dispatching
  // 'collection:rerendered') and append cards on load-more (no event) — either way the fresh
  // card HTML arrives with fit badges unfilled/hidden until applyPersonalization runs again.
  var lastGridApply = 0;
  var gridApplyQueued = false;
  function queueGridPersonalize() {
    if (gridApplyQueued) return;
    // applyPersonalization itself mutates card text nodes, which re-fires the observer —
    // the timestamp window swallows that echo without blocking real re-renders.
    if (Date.now() - lastGridApply < 150) return;
    gridApplyQueued = true;
    setTimeout(function () {
      gridApplyQueued = false;
      lastGridApply = Date.now();
      applyPersonalization();
      applyView();
    }, 60);
  }
  function watchGrid() {
    document.addEventListener('collection:rerendered', queueGridPersonalize);
    var grid = document.getElementById('ProductGridContainer');
    if (grid && window.MutationObserver) {
      new MutationObserver(queueGridPersonalize).observe(grid, { childList: true, subtree: true });
    }
  }

  // Live company rating for [data-pj-rating] (home hero pill). Pulls the Reviews.io
  // company average from the PUBLIC merchant endpoint keyed by the store domain — no
  // API key. Cached 6h in sessionStorage; on any failure the SSR fallback value stays.
  function applyLiveRating() {
    var els = $all('[data-pj-rating]');
    if (!els.length) return;
    var STORE = 'thepetstandard.com.au'; // Reviews.io company store id (matches pj-reviews.liquid)
    var KEY = 'pjRating';
    function paint(v) { var s = (Math.round(v * 10) / 10).toFixed(1); els.forEach(function (el) { el.textContent = s; }); }
    try { var c = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (c && c.v > 0 && (Date.now() - c.t) < 216e5) { paint(c.v); return; } } catch (e) {}
    fetch('https://api.reviews.io/merchant/latest?store=' + encodeURIComponent(STORE), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var avg = j && j.stats && parseFloat(j.stats.average_rating);
        if (!avg || avg <= 0) return; // keep SSR fallback
        paint(avg);
        try { sessionStorage.setItem(KEY, JSON.stringify({ v: avg, t: Date.now() })); } catch (e) {}
      })
      .catch(function () {}); // silent — SSR fallback stays
  }

  function init() { readConfig(); bind(); bindQuiz(); applyView(); applyPersonalization(); renderPetSwitch(); applyPaws(); applyRewards(); watchGrid(); applyLiveRating(); document.dispatchEvent(new CustomEvent('pj:view', { detail: { view: view } })); render(); }

  window.PJ = { addToCart: addToCart, openCart: openCart, closeCart: closeCart, refresh: render, setView: setView, getView: function () { return view; }, openQuiz: openQuiz, getPet: getPet, personalize: applyPersonalization, money: money };

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
